import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { CheckPermission } from '../../../components/CanUser';
import CardHeaderless from '../../../components/CardHeaderless';
import ExtendedTable from '../../../components/ExtendedTable';
import PageHeader from '../../../components/PageHeader';
import Spinner from '../../../components/Spinner';
import { UserContext } from '../../../context/userContext';

import organizationService from '../../../services/organizationService';

export default function OrganizationPage() {
  document.title = 'Organizations | Today\'s Family Fridge';

  const history = useHistory();
  const userState = useContext(UserContext);

  const [pageTitle, setPageTitle] = useState('Organizations');

  const [organizations, setOrganizations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isShowingArchived, setIsShowingArchived] = useState(false);

  const tableClickEvent = (e, r) => { history.push('/organizations/edit/' + r.organizationId); };
  const tableColumns = [
    { text: 'Name', dataField: 'name', sort: true },
    { text: '# of Locations', dataField: 'numberOfLocations', sort: true },
    { text: '# of Classrooms', dataField: 'numberOfClassrooms', sort: true },
    { text: '# of Families', dataField: 'numberOfFamilies', sort: true },
    { text: '# of Parent/Guardian(s)', dataField: 'numberOfGuardians', sort: true },
    { text: '# of Caregivers', dataField: 'numberOfCaregivers', sort: true },
    { text: '# of Children', dataField: 'numberOfChildren', sort: true },
  ];

  let canView = true;
  if (!CheckPermission(userState.user.role, 'organizations:visit') && typeof userState.user.role !== 'undefined') {
    canView = false;
    history.push('/error/404');
  }

  const loadOrganizations = async () => {
    if (canView) {
      setPageTitle(isShowingArchived ? 'Archived Organizations' : 'Organizations');

      await organizationService
        .all(isShowingArchived)
        .then((r) => setOrganizations(r.model))
        .finally(() => setIsLoading(false));
    }
  };

  useEffect(() => { loadOrganizations(); }, [isShowingArchived]);

  return (
    <main className="main" id="top">
      <PageHeader
        title={pageTitle}
        userRole={userState.user.role}
        addPermission="organizations:create"
        newButtonText="an Organization"
        newButtonUrl="/organizations/edit"
        isShowingArchived={isShowingArchived}
      />

      {isLoading
        ? <Spinner />
        : (
          <CardHeaderless>
            <ExtendedTable
              isShowingArchived={isShowingArchived}
              archiveClicked={() => setIsShowingArchived(!isShowingArchived)}
              archivePermission="organizations:view-archive"
              userRole={userState.user.role}
              columns={tableColumns}
              data={organizations}
              tableClickEvent={tableClickEvent}
              keyField="organizationId"
              defaultSort="name"
            />
          </CardHeaderless>
        )}
    </main>
  );
}
